module.exports = __webpack_public_path__ + "static/media/sm.3ee1b852.svg";